import React, { Suspense } from "react";

class RouteErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 text-center" role="alert">
          <p>Unable to load this page. Please reload to try again.</p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default function RouteBoundary({ children }) {
  return (
    <RouteErrorBoundary>
      <Suspense
        fallback={
          <div className="p-4 text-center" role="status" aria-live="polite">
            Loading page...
          </div>
        }
      >
        {children}
      </Suspense>
    </RouteErrorBoundary>
  );
}
